import { ButtonMenuItem } from '@components/Menu/ButtonMenuItem.tsx';
import { DropdownMenuItem } from '@components/Menu/DropdownMenuItem.tsx';
import {
  type HTMLAttributeAnchorTarget,
  type ReactElement,
  useId,
} from 'react';
import { LinkMenuItem } from '@components/Menu/LinkMenuItem.tsx';
import { MenuItemType } from '@src/config/constants';
import { type MenuItemContentProps } from './MenuItemContent';

export const MenuItem = ({
  type,
  href,
  onClick,
  dropDownMenuEntries,
  ...menuItemProps
}: {
  className?: string;
} & Pick<
  MenuItemContentProps,
  'icon' | 'picture' | 'label' | 'showLabel' | 'labelClass' | 'isSubMenuItem'
> &
  (
    | {
        type: MenuItemType.LINK;
        onClick?: never;
        href: string;
        target?: HTMLAttributeAnchorTarget;
        dropDownMenuEntries?: never;
      }
    | {
        type: MenuItemType.DROPDOWN;
        onClick?: never;
        href?: never;
        target?: never;
        dropDownMenuEntries: ReactElement[];
      }
    | {
        type: MenuItemType.BUTTON;
        onClick: () => void;
        href?: never;
        target?: never;
        dropDownMenuEntries?: never;
      }
  )) => {
  const labelId = useId();

  switch (type) {
    case MenuItemType.LINK:
      return <LinkMenuItem labelId={labelId} href={href} {...menuItemProps} />;
    case MenuItemType.BUTTON:
      return (
        <ButtonMenuItem
          labelId={labelId}
          onClick={onClick}
          {...menuItemProps}
        />
      );
    case MenuItemType.DROPDOWN:
      return (
        <DropdownMenuItem
          labelId={labelId}
          dropDownMenuEntries={dropDownMenuEntries}
          {...menuItemProps}
        />
      );
  }
};
